import * as monthAPI from '../api/months'
import * as types from "../mutation-types"

// initial state
const months = {
    namespace: 'months',

    state: {
        all: [],
    },

    getters: {
        months: (state) => state.all.sort((a,b) => a.order - b.order),
    },

    mutations: {
        [types.UPDATE_MONTH] (state, month) {
            let monthIndex = state.all.indexOf(state.all.find(mth => mth.id === month.id));
            if (monthIndex === -1) {
                window.alert('error updating month, try refreshing')
            }

            state.all.splice(monthIndex, 1, month)
        }
    },

    actions: {
        [types.UPDATE_MONTH]: ({commit, dispatch, state}, month) => {
            return new Promise((resolve, reject) => {
                monthAPI.updateMonth(commit, month)
                    .then(data => {
                        commit(types.UPDATE_MONTH, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        }
    },
};

export default months;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/months/index.js
// module id = 616
// module chunks = 0